import { observer } from "mobx-react-lite";
import React, { useState, useMemo } from "react";

import { ViewUser } from "../../../../services/authorization/Permissions";
import useUrlParams from "../../../../services/url/UrlParamsService";
import { UserInViewStorageModel } from "../../../../services/user/UserInViewStorage";
import PageLayout from "../../../_layout/PageLayout";
import { UserMenuItemsModel } from "../../UserMenuItems";
import { api } from "../../../../services/api/ApiService";
import DataGrid from "../../../../components/datatable/DataGrid";
import { UsersVaUsageStorageModel } from "../../../../services/user/UserVaUsageStorage";
import { CurrentOrganizationStorageModel } from "../../../../services/organization/CurrentOrganizationStorage";

export default observer(() => {
  const urlParamsService = useUrlParams();

  const userInViewId = urlParamsService.getUserId()!;

  const [userInViewStorage] = useState(() =>
    UserInViewStorageModel.create({ userInViewId: userInViewId }, { api })
  );

  const [currentOrganizationStorage] = useState(() =>
    CurrentOrganizationStorageModel.create({}, { api })
  );

  const menuItems = useMemo(() => {
    const userMenuItems = UserMenuItemsModel.create({
      userId: userInViewId,
      isLoading: userInViewStorage.isLoading,
      organizationHasStripeCustomer: currentOrganizationStorage.organization.hasStripeCustomer,
    });

    return {
      staticItems: userMenuItems.getStaticItems(),
    };
  }, [
    currentOrganizationStorage.organization.hasStripeCustomer,
    userInViewId,
    userInViewStorage.isLoading,
  ]);

  const [usersVaUsageStorage] = useState(() =>
    UsersVaUsageStorageModel.create({ userId: userInViewId, useGridFiltering: true }, { api })
  );

  return (
    <PageLayout
      accessWithOneOfThePermissions={[ViewUser]}
      titleKey={
        userInViewStorage.userInView.name
          ? "ViewUser.title-usage"
          : "ViewUser.title-usage-no-username"
      }
      titleContext={{ userName: userInViewStorage.userInView.name }}
      id="view-user-usage"
      menuItems={menuItems}
      isLoading={userInViewStorage.isLoading}
    >
      <DataGrid itemTypeKey={""} dataGridStorage={usersVaUsageStorage} />
    </PageLayout>
  );
});
